// -----------------------------------------------------------------------------
// Scripts for menu mobile
// -----------------------------------------------------------------------------

function menuMobile() {

  $('.navbar-toggler').on('click', function () {
    $('.menu-mobile').addClass('menu-mobile--open');
    $('#header-search-mobile').addClass("header-search-mobile--active");
    $('body').addClass('no-scroll');
  });

  $('.menu-mobile__close, #contactMenuBtn').on('click', function () {
    $('.menu-mobile').removeClass('menu-mobile--open');
    $('#header-search-mobile').removeClass("header-search-mobile--active");
    $('body').removeClass('no-scroll');
  });

}

if ( $(window).width() < 992 ) {
  var btn = $('#contactMenuBtn');
  var search = $('.header__search');
  btn.addClass("header__contact--mobile");

  btn.on('click', function() {
    $('.current-menu-item').removeClass("current-menu-item");
    $('#contactElement').addClass("current-menu-item");
  });

  $('#primary-menu').append('<li class="menu-item menu-item-type-post_type menu-item-object-page" id="contactElement"></li>');
  $('#contactElement').append(btn);

  $('#header-search-mobile').append(search);
  $('.header__search').addClass("header__search--mobile");
}